import type { IconProp } from '@fortawesome/fontawesome-svg-core'
import { faSpinner } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import clsx from 'clsx'
import type React from 'react'
import type { ReactElement } from 'react'
import { iconFixedWidth, item, itemDisabled } from './ActionsMenu.css'

interface ActionsMenuItemProps {
  icon?: IconProp
  title: string
  link?: string
  disabled?: boolean
  loading?: boolean
  onClick?: (e: React.MouseEvent<HTMLSpanElement, MouseEvent>) => void
}

export const ActionsMenuItem = ({
  icon,
  title,
  link,
  disabled,
  loading = false,
  ...rest
}: ActionsMenuItemProps): ReactElement => {
  const onclick = (): void => {
    if (disabled) {
      return
    }
    if (link !== undefined) {
      window.location.href = link
    }
  }
  return (
    <span
      className={clsx([item, disabled ? itemDisabled : null])}
      onClick={onclick}
      {...rest}
    >
      {icon !== undefined && (
        <FontAwesomeIcon
          icon={loading ? faSpinner : icon}
          spin={loading}
          className={iconFixedWidth}
        />
      )}
      {title}
    </span>
  )
}
